// extracted by mini-css-extract-plugin
module.exports = {"root":"enpL4B8b","scrollableRoot":"b9euqrtN","title":"_6os5q_7c","article":"UOHpa3Ls"};